import { Container, Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import ApplicationList from "../components/ApplicationList";

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: "right", mt: 3 }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/new-application")}
        >
          New User
        </Button>
      </Box>

        <ApplicationList />

    </Container>
  );
};

export default HomePage;
